import React, { createRef, Fragment, useEffect, useState } from 'react';
import { shape, func, arrayOf, bool, array } from 'prop-types';
import isEmpty from 'lodash.isempty';

const Demographics = ( props ) => {

    const {
        emit,
        demographics,
        disabled,
        disabledDemographics,
        clearChart
    } = props;

    const [ activeDemographics, setActiveDemographics ] = useState( [] );

    const updateDemographics = ( key, isChecked, subDependents ) => {

        if ( activeDemographics.length < 2 && isChecked ) {

            setActiveDemographics( [ ...activeDemographics, key ] );

        }

        if ( !isChecked && activeDemographics.includes( key ) ) {

            const curState = activeDemographics.slice();

            curState.splice( curState.indexOf( key ), 1 );

            setActiveDemographics( curState );

        }

        clearChart();

    };

    const renderDemographics = () => {

        return demographics.map( ( demoGroup, idx ) => {

            let combinedData = [];

            Object.keys( demoGroup.data ).forEach(
                ( key ) => ( combinedData = [ ...combinedData, ...demoGroup.data[key] ] )
            );
            const hasSubs = combinedData.some( ( d ) => d['sub-demographics'] );


            return (
                <div
                    key={ `demoGroup-${ idx }` }
                    className={ `ude-demographics-filter ${ hasSubs ? 'ude-demographics-filter-hassubs' : ''
                        }` }
                >
                    { demoGroup.columnTitle && (
                        <p className='demogroup-column-title'>
                            { demoGroup.columnTitle }
                        </p>
                    ) }
                    <div className='ude-demographic-groups'>
                        { Object.keys( demoGroup.data ).map( ( key ) => {

                            return (
                                <div className={ key === 'race/ethnicity' ? 'race-ethnicity' : key } id={ key } key={ key }>
                                    { demoGroup.data[key].map( ( demo ) => {

                                        const demoDisabled = disabledDemographics.some(
                                            ( el ) => el.bin === demo.bin && el.class === demo.class
                                        );
                                        const key = `${ demo.bin }-${ demo.class }`;
                                        const demoRef = createRef();
                                        const subGroupKeys = [];

                                        return (
                                            <Fragment key={ key }>
                                                <div
                                                    className={ `sub-demo-checkbox ${ [
                                                        activeDemographics.length >= 2 &&
                                                            !activeDemographics.includes( key )
                                                            ? 'disabled'
                                                            : '',
                                                        demo['sub-demographics'] ? 'sub-demo' : '',
                                                        demoDisabled ? 'disabled' : ''
                                                    ].join( ' ' ) }` }
                                                >
                                                    <input
                                                        id={ key }
                                                        ref={ demoRef }
                                                        type='checkbox'
                                                        checked={ !disabledDemographics.some( ( d ) =>
                                                            activeDemographics.includes(
                                                                `${ d['bin'] }-${ d['class'] }`
                                                            )
                                                        ) && activeDemographics.includes( key ) }
                                                        onChange={ () =>
                                                            updateDemographics(
                                                                key,
                                                                demoRef.current.checked,
                                                                subGroupKeys
                                                            ) }
                                                    />
                                                    <label htmlFor={ key }>{ demo.label }</label>
                                                    { demo.rollover.length ? (
                                                        <p className='ude-demographics-filter-rollover'>
                                                            { demo.rollover }
                                                        </p>
                                                    ) : (
                                                        ''
                                                    ) }
                                                </div>
                                                { !isEmpty( demo['sub-demographics'] ) && (
                                                    <div className='has-sub-list'>
                                                        { demo['sub-demographics'].map( ( subDemo ) => {

                                                            const subKey = `${ subDemo.bin }-${ subDemo.class }`;
                                                            const subRef = createRef();

                                                            let subDemoDisabled = false;

                                                            if (
                                                                disabledDemographics.some(
                                                                    ( el ) =>
                                                                        el.bin === subDemo.bin &&
                                                                        el.class === subDemo.class
                                                                )
                                                            ) {

                                                                subDemoDisabled = true;

                                                            }

                                                            return (
                                                                <div
                                                                    key={ subKey }
                                                                    className={ `sub-demo-checkbox ${ [
                                                                        activeDemographics.length >= 2 &&
                                                                            !activeDemographics.includes( subKey )
                                                                            ? 'disabled'
                                                                            : '',
                                                                        subDemoDisabled ? 'disabled' : ''
                                                                    ].join( ' ' ) }` }
                                                                >
                                                                    <input
                                                                        id={ subKey }
                                                                        ref={ subRef }
                                                                        type='checkbox'
                                                                        checked={ activeDemographics.includes(
                                                                            subKey
                                                                        ) }
                                                                        onChange={ () =>
                                                                            updateDemographics(
                                                                                subKey,
                                                                                subRef.current.checked,
                                                                                key
                                                                            ) }
                                                                    />
                                                                    <label htmlFor={ subKey }>
                                                                        { subDemo.label }
                                                                    </label>
                                                                    { subDemo.rollover.length ? (
                                                                        <p className='ude-demographics-filter-rollover'>
                                                                            { subDemo.rollover }
                                                                        </p>
                                                                    ) : (
                                                                        ''
                                                                    ) }
                                                                </div>
                                                            );

                                                        } ) }
                                                    </div>
                                                ) }
                                            </Fragment>
                                        );

                                    } ) }
                                </div>
                            );

                        } ) }
                    </div>
                </div>
            );

        } );

    };

    useEffect( () => {

        const result = [];

        if ( disabled ) {

            if ( activeDemographics.length > 0 ) {

                setActiveDemographics( [] );

            }

            emit( result );

            return;

        }

        for ( const dem of activeDemographics ) {

            const activeDemo = dem.split( '-' )[0];
            const demoData = demographics.filter( ( el ) => el.data[activeDemo] )[0];
            const firstLevel = !isEmpty( demoData ) ? demoData.data[activeDemo] : [];

            if ( !firstLevel.length ) {

                const activeSubDemo = activeDemo.includes( '(detailed)' ) ? activeDemo.split( '(detailed)' )[0].trim() : activeDemo.trim();
                const subDemoData = demographics.filter( ( el ) => el.data[activeSubDemo] )[0];
                const secondLevel = subDemoData.data[activeSubDemo];
                const filteredDemographics = secondLevel.filter( ( d ) => d.hasOwnProperty( 'sub-demographics' ) );
                const filteredSubDemographics = filteredDemographics[0]['sub-demographics'];
                const found = filteredSubDemographics.find(
                    ( d ) => `${ d['bin'] }-${ d['class'] }` === dem
                );

                if ( found ) result.push( found );

            }
            else {

                const found = firstLevel.find(
                    ( d ) => `${ d['bin'] }-${ d['class'] }` === dem
                );

                if ( found ) result.push( found );

            }

        }

        emit( result );

    }, [ activeDemographics ] );


    const clearAllDemographics = () => {

        setActiveDemographics( [] );
        clearChart();

    };

    return (
        <div
            className={ [ disabled ? 'ude-disabled' : '', 'ude-demographics' ].join( ' ' ) }
        >
            <div className='ude-demographics-header'>
                <h2>Demographics</h2>
                <span>(select up to 2)</span>
            </div>

            { activeDemographics.length > 0 && (
                <a
                    onClick={ clearAllDemographics }
                    className='ude-demographics-clearall'
                >
                    Clear All Demographics
                </a>
            ) }

            <div className='ude-demographics-filterwrapper'>
                { renderDemographics() }
            </div>

            <span className='ude-demographics-bottominfo'>
                Note: Not all data are available for all selections; Large,
                single-quarter fluctuations may reflect periodic issues with the
                reporting of data by lenders. Users should interpret with caution.
            </span>
        </div>
    );

};

Demographics.propTypes = {
    demographics: arrayOf(
        shape( {
            data: shape( {} )
        } )
    ).isRequired,
    emit: func.isRequired,
    disabled: bool.isRequired,
    disabledDemographics: array,
    clearChart: func.isRequired
};

export default Demographics;
